.shell {
  min-height: 100dvh;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  background: var(--secondary);
}

.surface {
  width: min(400px, 100%);
  margin-block: auto;
}

.topBar {
  width: 100%;
  margin: 0 0 16px;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.logo {
  width: 48px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  margin-bottom: 16px;
  overflow: hidden;
}

.logoImage {
  width: 48px;
  height: 48px;
  display: block;
  border-radius: var(--radius-sm);
}

.title {
  margin: 16px 0;
  font-size: var(--font-size-heading-md);
  font-weight: var(--font-weight-semibold);
  color: var(--foreground);
}

.description {
  margin: 0;
  max-width: 36ch;
  font-size: var(--font-size-sm);
  line-height: 1.5;
  color: var(--foreground-secondary);
}

.body {
  display: grid;
  gap: 16px;
  width: 100%;
  margin-top: 16px;
}

.footer {
  width: 100%;
  display: grid;
  gap: 12px;
  margin-top: 16px;
}

.footerNote {
  margin-top: 32px;
  max-width: 280px;
  justify-self: center;
  font-size: var(--font-size-sm);
  color: var(--foreground-tertiary);
  line-height: 1.5;
  text-align: center;
}

.loadingBlock {
  align-items: center;
  color: var(--foreground-tertiary);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  justify-content: center;
  margin-bottom: var(--spacing-8);
  margin-top: var(--spacing-8);
  min-height: 56px;
  width: 100%;
}

.loadingLabel {
  color: var(--muted-foreground);
  font-size: var(--font-size-sm);
  line-height: 1.5;
  margin: 0;
  text-align: center;
}

@media (max-width: 768px) {
  .shell {
    padding: 16px 12px;
  }

  .content {
    padding: 32px 24px 24px;
  }
}
